import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { ConsumptionBasedScopeTwo } from "../../../../api/supplier-questionnaire/tabs";

export const consumptionBasedScopeTwoKeys = {
  items: () => ["consumptionBasedIndirectEmissionsItems"]
};

export function useGetConsumptionBasedIndirectEmissionsItems(params, config) {
  const { callApi } = useAuth();
  return useQuery([...consumptionBasedScopeTwoKeys.items(), params.type, params.queryParams.page],
    () => callApi(ConsumptionBasedScopeTwo.getConsumptionBasedIndirectEmissionsItems, params), config);
}

export function useAddConsumptionBasedIndirectEmissionsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data, type }) =>
    callApi(ConsumptionBasedScopeTwo.addConsumptionBasedIndirectEmissionsItem, { questionnaireId, data, type }), config);
}

export function useUpdateConsumptionBasedIndirectEmissionsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data, type }) =>
    callApi(ConsumptionBasedScopeTwo.updateConsumptionBasedIndirectEmissionsItem, {
      questionnaireId,
      recordId,
      data,
      type
    }), config);
}

export function useDeleteConsumptionBasedIndirectEmissionsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, type }) =>
    callApi(ConsumptionBasedScopeTwo.deleteConsumptionBasedIndirectEmissionsItem, {
      questionnaireId,
      recordId,
      type
    }), config);
}